@if (!canView) {
    <div>
        {{ 'pg-resource-embed.no-view' | locTranslate }}
    </div>
}
<pg-resource-view-host [hidden]="!canView"></pg-resource-view-host>

